import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Colors from "../../theme/colors.json";
import { MenuItem, Select } from "@mui/material";
import { INITIAL_THEME } from "../../theme";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { getProductPremium } from "../../services/ChartService";
import { pushNotification } from "../../redux/actions";
import CONSTANTS, { Chart_Errors } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import NoData from "./NoData";

const data = [
  {
    name: "Health",
    Monthly: 4000,
    Yearly: 2400,
  },
  {
    name: "Term",
    Monthly: 3000,
    Yearly: 1398,
  },
  {
    name: "Motor",
    Monthly: 2000,
    Yearly: 9800,
  },
  {
    name: "Fire",
    Monthly: 2780,
    Yearly: 3908,
  },
  {
    name: "Glass",
    Monthly: 1890,
    Yearly: 4800,
  },
  {
    name: "Marine",
    Monthly: 2390,
    Yearly: 3800,
  },
];

const useStyles = makeStyles((theme) => ({
  responsiveContainer: {
    width: "100%",
    height: "100%",
    fontSize: theme.fontSizes.SMALL,
    paddingBottom: "2rem",
    display: "flex",
    justifyContent: "center",
  },
  filterContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "3%",
  },
  filtersSection: {
    display: "flex",
    gap: "3%",
    // justifyContent: "space-around",
    // width: "50%",
  },
  selectStyles: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSizes.SMALL,
    height: "1.6rem",
    minWidth: "5rem",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "& .MuiSvgIcon-root": {
      fill: `${theme.palette.primary.main} !important`,
    },
  },
  graphHeading: {
    fontSize: theme.fontSizes.LARGE,
    fontWeight: 600,
    // color: theme.palette.secondary.main,
  },
}));

const ProductwisePremiumChart = ({ years, months }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedYear, setSelectedYear] = useState(
    years[0]?.value || new Date().getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleGetProductPremium = async () => {
    setIsLoading(true);
    const response = await getProductPremium(selectedYear, selectedMonth);
    if (response?.success) {
      setChartData(response?.data);
      setIsLoading(false);
      // dispatch(
      //   pushNotification({
      //     isOpen: true,
      //     message: response.message,
      //     type: CONSTANTS.SUCCESS,
      //   })
      // );
    } else {
      setChartData([]);
      setIsLoading(false);
      // dispatch(
      //   pushNotification({
      //     isOpen: true,
      //     message: response.message,
      //     type: CONSTANTS.ERROR,
      //   })
      // );
    }
  };

  useEffect(() => {
    handleGetProductPremium();
  }, [selectedYear, selectedMonth]);

  return (
    <>
      <div className={classes.filterContainer}>
        <div className={classes.graphHeading}>Product wise premium</div>
        <div className={classes.filtersSection}>
          <Select
            size="small"
            className={classes.selectStyles}
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {years?.map((item, index) => {
              return (
                <MenuItem key={index} value={item?.value}>
                  {item?.title}
                </MenuItem>
              );
            })}
          </Select>
          <Select
            size="small"
            className={classes.selectStyles}
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {months?.map((item, index) => {
              return (
                <MenuItem key={index} value={item?.value}>
                  {item?.title}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      </div>
      {chartData?.length > 0 && !isLoading && (
        <ResponsiveContainer className={classes.responsiveContainer}>
          <BarChart
            width={500}
            height={300}
            data={chartData}
            //   margin={{
            //     top: 0,
            //     right: 0,
            //     left: 0,
            //     bottom: 0,
            //   }}
            barGap={0}
            barSize={15}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="category" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="monthly"
              fill={Colors.GRAPH_SECONDARY_COLOR}
              activeBar={<Rectangle fill="pink" stroke="blue" />}
              isAnimationActive={false}
            />
            <Bar
              dataKey="yearly"
              fill={INITIAL_THEME.palette.primary.main}
              activeBar={<Rectangle fill="gold" stroke="purple" />}
              isAnimationActive={false}
            />
          </BarChart>
        </ResponsiveContainer>
      )}

      {chartData?.length === 0 && !isLoading && (
        <NoData errorLabel={Chart_Errors.productwisePremium_error} />
      )}
    </>
  );
};

export default ProductwisePremiumChart;
